import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IActiveDirectoryGroup {
  name: string; // group name
  domainName: string; // group's domain name
}

export interface ISyncActiveDirectoryGroupsParams {
  groups: IActiveDirectoryGroup[];
}

export class SyncActiveDirectoryGroupsRequest extends Request<ISyncActiveDirectoryGroupsParams, IResult> {
  constructor(groups: IActiveDirectoryGroup[]) {
    super('syncActiveDirectoryGroups', { groups: groups });
  }
}
